<template>
  <div
      class="absolute left-0 top-0 inline-flex h-8 w-8 items-start justify-start rounded-3xl p-2 m-3.5 md:m-6 hover:bg-neutral-200 gap-2.5 cursor-pointer"
      @click="$emit('action')">
    <div class="relative h-4 w-4">
      <BaseIcon class="h-4 w-4 text-neutral-600" :name="iconName"/>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  type: {
    type: String as PropType<'close' | 'back'>,
    default: null
  }
})

defineEmits(['action'])

const iconName = computed(() => {
  return props.type === 'close' ? 'close' : 'arrow'
})
</script>